import React from "react";
import { observer } from "mobx-react-lite";
import OrderItemDTO from "@/dto/order/OrderItemDTO";
import OrderStatus from "@/enum/OrderStatus";
import ShopType from "@/enum/ShopType";
import OrderItemImage from "../../../../../../../components/OrderItemImage";
import OrderItemTitleExternalIdPropElement from "../OrderItemsColumn/OrderItemTitleExternalIdPropElement";

interface OrderItemDisplayOnlyShowPicProps {
    orderItem: OrderItemDTO;
    orderStatus: OrderStatus;
    shopType: ShopType;
    hasAbnormal: boolean;
    picSize: number;
}

/**
 * 设置了只勾选显示图片 则使用此组件
 */
const OrderItemDisplayOnlyShowPic: React.FC<OrderItemDisplayOnlyShowPicProps> = observer(function (props) {
    const { orderItem, orderStatus, shopType, hasAbnormal, picSize } = props;

    if (orderItem.picture) {
        return (
            <span className="order-item-pic">
                <OrderItemImage
                    orderStatus={orderStatus}
                    orderItem={orderItem}
                    shopType={shopType}
                    showWarehouseWarning={true}
                    hasAbnormal={hasAbnormal}
                    size={picSize}
                />
                <span className={orderItem.quantity >= 2 ? "high-light-order-item-quantity" : "order-item-quantity"}>
                    {orderItem.quantity}
                    {orderItem.canceledQuantity > 0 ? (
                        <span className="text-danger font-bold fs11">（取消数量：{orderItem.canceledQuantity}）</span>
                    ) : null}
                </span>
            </span>
        );
    }

    // 如果没有图片，降级
    return (
        <OrderItemTitleExternalIdPropElement
            orderItem={orderItem}
            orderStatus={orderStatus}
            hasAbnormal={hasAbnormal}
        />
    );
});

export default OrderItemDisplayOnlyShowPic;
